import { EntityBase } from "./EntityBase";

/**
 * Middleware Type enum
 */
export enum MiddlewareType {
    AUTHENTICATION = "authentication",
    AUTHORIZATION = "authorization",
    VALIDATION = "validation",
    RATE_LIMITING = "rate_limiting",
    LOGGING = "logging",
    ERROR_HANDLING = "error_handling",
    CORS = "cors",
    COMPRESSION = "compression",
    CUSTOM = "custom",
}

/**
 * Middleware Interface
 * Represents middleware that can be applied to endpoints
 * Middlewares are standalone functional pieces (RBAC, auth, file upload, etc.)
 */
export interface MiddlewareInterface extends EntityBase {
    /** Name of the middleware */
    middlewareName: string;

    /** Description of what this middleware does (required for middleware) */
    description: string;

    /** Type of middleware */
    middlewareType: MiddlewareType;

    /** @deprecated Use functionIds instead - Single function reference */
    functionId?: string;

    /** Function IDs - References to function nodes that this middleware uses */
    functionIds?: string[];

    /** Success response codes and messages */
    successResponses: {
        statusCode: number;
        message?: string;
    }[];

    /** Failed/error response codes and messages */
    failedResponses: {
        statusCode: number;
        message?: string;
        schema?: Record<string, unknown>; // Response schema structure
    }[];

    /** Implementation steps/instructions - DEPRECATED: Should be in Function, not Middleware */
    /** @deprecated Implementation steps should be in the Function entity, not middleware */
    implementationSteps?: string[];

    /** Configuration options for the middleware */
    config?: Record<string, unknown>;

    /** Whether this middleware is enabled */
    enabled: boolean;

    /** Order/priority when multiple middlewares are applied */
    order?: number;

    /** Dependencies this middleware requires */
    dependencies?: {
        packages?: { name: string }[];
        services?: string[];
    };

    /** Service IDs required by this middleware (for edge creation) */
    servicesRequired?: string[];

    /** File path where this middleware will be generated */
    filePath?: string;

    /** File name for this middleware */
    fileName?: string;


}